import { render, staticRenderFns } from "./SalesPersons.vue?vue&type=template&id=076dd0dd"
import script from "./SalesPersons.vue?vue&type=script&lang=ts"
export * from "./SalesPersons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports